import { Box, Flex, Heading, Text, Skeleton } from "@chakra-ui/react";
import { lazy, Suspense, useEffect, useState } from "react";
import { MovieDetailCardWithVideoProps } from "../../../@types/MovieDetailCard";
import { LabelText } from "../../../components";

const ReactPlayer = lazy(() => import("react-player"));

function MovieDetailCardWithVideo_1({
  movieTitle,
  movieDescription,
  genre,
  duration,
  director,
  cast,
  release_date,
  videoLink,
}: MovieDetailCardWithVideoProps) {
  const defaultLabelTextProps = {
    fontWeight: "normal",
  };

  const [videoUrl, setVideoUrl] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setVideoUrl(videoLink);
    }
  }, [videoLink]);

  return (
    <Box p="1rem" px="1.25rem" background="primary.200">
      <Flex
        gap="2.5rem"
        direction={{
          base: "column",
          lg: "row",
        }}
      >
        <Box
          flexBasis={{
            base: "none",
            lg: "40%",
          }}
          height={{
            base: "25rem",
            lg: "20rem",
          }}
          width="100%"
        >
          {videoUrl && (
            <Suspense
              fallback={
                <Skeleton width="100%" height="100%" borderRadius="md" />
              }
            >
              <ReactPlayer url={videoUrl} width="100%" height="100%" />
            </Suspense>
          )}
        </Box>
        <Box
          sx={{
            flexBasis: "55%",
          }}
          itemScope
          itemType="http://schema.org/Movie"
          itemProp="movie"
        >
          <Heading itemProp="name">{movieTitle}</Heading>
          <Heading
            size="small"
            textTransform="uppercase"
            mt="1rem"
            itemProp="movie-info"
            title={genre}
          >
            {genre}
          </Heading>
          <Text
            mt="1rem"
            fontWeight="normal"
            color="surface.400"
            itemProp="description"
            title="description"
          >
            {movieDescription}
          </Text>
          <Flex direction="column" mt="1.5rem" gap="0.25rem">
            <LabelText
              label="director"
              itemProp="director"
              title={director}
              text={director}
              {...defaultLabelTextProps}
            />
            <LabelText
              label="cast"
              title="cast"
              itemProp="movie-cast"
              text={cast}
              {...defaultLabelTextProps}
            />
            <LabelText
              label="release on"
              title="release date"
              itemProp="datePublished"
              text={release_date}
              {...defaultLabelTextProps}
            />
            <LabelText
              label="duration"
              title="duration"
              itemProp="movie-duration"
              text={duration}
              {...defaultLabelTextProps}
            />
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
}

export default MovieDetailCardWithVideo_1;
